module.exports = __webpack_public_path__ + "copy-icon.svg?8fa6ee0ea53e229b1968104a09e81d1a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/copy-icon.svg
// module id = 35
// module chunks = 0